import { Component, SimpleChanges } from '@angular/core';
import { FieldTypeConfig, FormlyFormOptions } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material-legacy';

export interface SelectOptn {
  label: string;
  value: string;
}

@Component({
  selector: 'app-formly-select',
  templateUrl: './formly-select.component.html',
  styleUrls: ['./formly-select.component.scss']
})
export class FormlySelectComponent extends FieldType<FieldTypeConfig> {

  optionsSelect: SelectOptn[] = [];
  matTooltipTxt = "";

  ngOnInit() {
    this.optionsSelect = this.props.options as SelectOptn[];
    this.matTooltipTxt = this.optionsSelect.find(opt => opt.value == this.formControl.value)?.label;
    this.formControl.valueChanges.subscribe((change) => {
      this.matTooltipTxt = this.optionsSelect.find(opt => opt.value == change)?.label;
    })
  }
}
